export default "__VITE_ASSET__a27982aa__"